<template>
  <div v-for="(reply, index) in treeData" :key="index">
    <div :id="`reply_${reply.id}`" ref="targe" class="reply-item">
      <div class="avatar-profile" @click.stop="directReport(reply)">
        <img
          :src="reply.owner.avatarUrl"
          :onerror="isNightMode ? avatarDefaultDark : avatarDefault"
          class="avatar"
        >
      </div>

      <div class="reply">
        <div class="reply-top-info">
          <UserProfile :item-data="reply" :parent-owner="reply.owner" />

          <!-- <PraiseButton
          :comment-id="reply.commentId"
          :reply-id="reply.id"
          :thumbup-count="reply.thumbupCount"
          :is-thumb-up="reply.isThumbUp"
          :reply-content="reply.content"
          :comment-owner="reply.parentReply && reply.parentReply.owner"
          :reply-owner="reply.owner"
        /> -->
        </div>
        <ContentBody
          :key="`reply_${reply.id}`"
          type="reply"
          :data="reply"
          :sub-comment-id="reply.parentReplyId"
          :comment-owner="reply.owner"
          @click="onReplyClick($event, reply)"
        />

        <MenuBar :item-data="reply" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import GraphemeSplitter from 'grapheme-splitter';
import { toRefs, computed, defineComponent, ref } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';

// import { setTopicContent } from '../core/useTopicContent/index';
import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';
import avatarDefault from '../assets/img/avatar_default.png';
import avatarDefaultDark from '../assets/img/avatar_default_dark.png';

import UserProfile from './UserProfile.vue';
import ContentBody from './ContentBody.vue';
import MenuBar from './MenuBar.vue';
// import PraiseButton from './PraiseButton.vue';

export default defineComponent({
  name: 'ReplyItem',
  components: {
    UserProfile,
    ContentBody,
    MenuBar,
    // PraiseButton,
  },
  props: {
    commentId: {
      type: String,
      required: true,
      default: '',
    },
    // reply: {
    //   type: Object,
    //   required: true,
    //   default() {
    //     return {};
    //   },
    // },
    treeData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    commentOwner: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['update:loadedReplySize'],

  setup(props, { emit }) {
    const { onCommentClickThrottle } = useOnCommentClickInject();
    const { feature, isNightMode, userMeta } = toRefs(useGlobalState());

    const initMaxLength = 75;
    const splitter = new GraphemeSplitter();

    const targe = ref(null);

    const { reply } = toRefs(props);

    const onReplyClick = (event, reply) => {
      // if (feature.value.enableSecondCommentDetail) {
      // 冒泡至祖先层元素事件处理
      // } else {
      onCommentClickThrottle(reply, {
        directComment: true,
      });
      event.stopPropagation();
      // }
    };

    const directReport = (reply) => {
      commonCommentStat(20084690, {
        userId: reply.owner.id,
      });

      if (userMeta.value.uid === reply.owner.id) {
        return;
      }

      onCommentClickThrottle(reply, {
        directReport: true,
      });
    };

    // nextTick(() => {
    //   setTopicContent(reply.value);
    // });

    return {
      isNightMode,

      avatarDefault,
      avatarDefaultDark,

      targe,

      onReplyClick,
      directReport,

    };
  },
});
</script>

<style scoped lang="scss">
@import "../assets/css/styling-mixin.scss";

.reply-item {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

// .reply-item:not(:last-child) {
.reply-item {
  padding: 6px 48px 0 180px;
}

.reply-item:not(:first-child) {
  margin-top: 0;
}

.reply-detail,
.reply-tip {
  font-family: ColorFont-Regular, "OPlusSans 3.0";
  font-weight: normal;
  font-size: 42px;
  letter-spacing: 0;
  line-height: 60px;
}

:deep(.topic-tag) {
  color: rgba(38, 96, 245, 1);
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.reply-tip {
  font-weight: 500;
  color: rgba($color: #000, $alpha: 0.55);
}

.reply-username {
  font-weight: 500;
  font-size: 42px;
}

.reply-remove {
  float: right;
  height: 57px;
  padding-top: 6px;
  font-family: ColorFont-Regular, "OPlusSans 3.0";
  font-size: 36px;
  color: #494949;
  line-height: 57px;
}

.avatar-profile {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 66px;
  position: relative;
  margin-top: 15px;
  &:active {
    transform: scale(0.8);
    transition: all 0.3s ease;
  }

  @include setRounded1pxBorder(rgba(0, 0, 0, 0.1), before, 72px);

  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 66px;
    margin-top: 0;
    vertical-align: top;
  }
}

.reply {
  margin-left: 24px;
  flex: 1;
  font-size: 36px;
  font-family: ColorFont-Regular, "OPlusSans 3.0";
  min-width: 0; // fix flex & ellipsis

  .reply-top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0 15px;
  }
}

.reply-bar {
  display: flex;
  align-items: center;
  line-height: 48px;
}

.time {
  font-weight: 400;
  color: rgba($color: #000, $alpha: 0.26);
  margin: 12px 0;
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.3);
  }
}

.place {
  color: rgba($color: #000, $alpha: 0.26);
  &::before {
    content: "·";
    margin: 0 6px;
  }
}

html[data-theme="dark"] {
  .reply-username {
    color: rgba(255, 255, 255, 0.7);
  }
  .reply-tip {
    color: rgba(255, 255, 255, 0.7);
  }
}
</style>
